module.exports = __webpack_public_path__ + "question.3cc4590c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/question.png
// module id = 1510
// module chunks = 0